<template>
  <Login v-if="$route.name === 'login'"/>

  <RegisterBrand v-else-if="$route.name === 'register.brand'"/>
  <template v-else-if="$route.name === 'register.brand.setup'">
    <Suspense>
      <RegisterBrandSetup />
    </Suspense>
  </template>

  <ForgotPassword v-else-if="$route.name === 'password.request'"/>
  <ResetPassword v-else-if="$route.name === 'password.reset'"/>
  <CampaignCreate v-else-if="$route.name === 'campaign.create' || $route.name === 'campaign.edit.draft'"/>
  <Error v-else-if="$route.path === '/error'"/>
  <Access v-else-if="$route.path === '/access'"/>
  <NotFound v-else-if="$route.path === '/notfound'"/>

  <template v-else-if="isAuth && isRegistrationFinished">
    <App
      v-if="isBrand"
      :theme="theme"
      :colorScheme="colorScheme"
      :componentTheme="componentTheme"
    />

    <AppMobile v-else />
  </template>


  <Toast/>
  <ConfirmDialog/>
  <VueQueryDevTools/>
</template>

<script setup>
import App from './App.vue';
import Error from './pages/Error';
import Access from './pages/Access';
import Login from './pages/auth/Login';
import NotFound from './pages/NotFound';
import CampaignCreate from './pages/CampaignCreate';
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import {useStore} from "vuex";
import {VueQueryDevTools} from "vue-query/devtools";
import {useQueryProvider} from "vue-query";
import {computed, ref, watchEffect} from "vue";
import {queryClient} from './client';
import {useAuth} from "./hooks/useAuth";
import RegisterBrand from "./pages/registration/brand/PersonalData";
import RegisterBrandSetup from "./pages/registration/brand/Setup";
import {useRole} from "./hooks/useRole";
import AppMobile from "./AppMobile";
import {useUser} from "./hooks/useUser";
import {useNotifications} from './hooks/useNotifications';

useQueryProvider(queryClient);

const {isBrand} = useRole();
const {isAuthenticated} = useAuth();
const {isRegistrationFinished} = useUser();
const store = useStore();
const {startListening, getNotificationsAndStoreIt} = useNotifications();

let theme = ref('blue');
let componentTheme = ref('blue');
let colorScheme = ref('light');

const isAuth = computed(() => {
  return isAuthenticated.value;
});

watchEffect(async (onInvalidate) => {
  if (isAuth.value && isBrand.value) {
    await getNotificationsAndStoreIt();
    startListening();
  }
})

</script>

<style scoped>
</style>
